import { apiExpress } from 'lib/config';
import { useQueryFetch } from './useQueryFetch';

export interface VideoData {
  title: string;
  filename: string;
  id?: number | string;
  isFreemium?: boolean;
  isGuide?: boolean;
  folder?: string | number;
}

export interface CreateVideoResponse {
  success: boolean;
  url: string;
  html: string;
  id: string;
  video_id: string;
  data?: any;
}

export const useCreateVideo = (isFreemium?: boolean) => {
  const { data, error, loading, fetchData, progress } = useQueryFetch({
    pathname: '',
  });
  const fetch = (data: VideoData) => {
    fetchData(
      {
        method: 'post',
        url: '/videos',
        baseURL: apiExpress,
        data: {
          filename: data.filename,
          title: data.title,
          isFreemium,
          isGuide: !!data.isGuide,
          folder: data.folder || 'Primary',
        },
      },
      data.hasOwnProperty('id') ? data.id : undefined
    );
  };

  const videoData: CreateVideoResponse = data || null;

  return { videoData, loading, error, fetch, progress };
};
